import Vue from 'vue';
import Router from 'vue-router';
import RegisterRefi from './views/refi-digital/RegisterRefi.vue';
import RegisterRefiDigital from './views/refi-digital/RegisterRefiDigital.vue';

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      name: '404',
      beforeEnter() {
        window.location.href = 'https://www.omni.com.br/404';
      },
    },
    {
      path: '/',
      name: 'root',
      redirect: {
        name: 'register-refi',
      },
    },
    {
      path: '/cadastro',
      name: 'cadastro',
      redirect: {
        name: 'register-refi',
      },
    },
    {
      path: '/cadastro-refi',
      name: 'register-refi',
      component: RegisterRefi,
    },
    {
      path: '/cadastro-refi-digital',
      name: 'register-refi-digital',
      component: RegisterRefiDigital
    }
  ],
});
